

















































































# import settings from '@/settings'
import evaluation from '@/components/skills_tab/evaluation'
import custom_skill from '@/components/skills_tab/custom_skill'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'
import m from '@/graphql/mutation'

export default {
    name: 'users_skills'

    components: {
        evaluation, custom_skill
    }

    props:
        uid:
            type: String
        direct:
            type: Boolean
            required: false

    data: ()->
        errors: {}
        active_names: [1]
        activeName: '1'
        skill_creation_explanation: "Création : écrire le nom de la compétence puis le sélectionner dans la liste déroulante en cliquant dessus."
        reload_custom_skill: false
        custom_skill: {
            user_uid: ''
            skill_uid_or_new: ''
            eval_uid:''
            minimal_level_waited:''
        }
        custom_skills: []

    computed:
        toggle_collapse_text: ()->
            text = "Ajouter une compétence personnelle"
            if @active_names.length > 1
                text = "Fermer"
            return text

        toggle_collapse_icon: ()->
            class_icon = 'mdi-plus-circle-o'
            if @active_names.length > 1
                class_icon = 'mdi-close-circle-o'
            return class_icon

    methods:
        has_access_right: t.has_access_right

        collapse_change: (value)->
            # console.log "VUE TOGGLE ", value
            @custom_skill = {
                user_uid: ''
                skill_uid_or_new: ''
                eval_uid:''
                minimal_level_waited:''
            }
            return

        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        reload_company_custom_skills: ()->
            @get_company_custom_skills()
            return

        save: ()->
            self = @
            @custom_skill.user_uid = @uid
            @custom_skill.minimal_level_waited = 0
            m.run('save_custom_skill', [@custom_skill])
            .then (resp)->
                if resp.body.data.user_custom_skill_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.user_custom_skill_form_mutation.errors.length > 0
                    self.errors = resp.body.data.user_custom_skill_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    n.success()
                    self.active_names = [1]
                    self.get_company_custom_skills()
                    self.reload_custom_skill = !self.reload_custom_skill
            .catch (resp)->
                n.catch_error(resp, "users_skills: save()")

        get_company_custom_skills: ()->
            self = @
            q.run('get_company_custom_skill_set', [@$store.getters.current_company.uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("users_skills: get_company_custom_skills: then", e.message)
                else
                    # console.log "GET COMPANY CUSTOM SKILLS : ", resp.body.data.company_custom_skill_set
                    self.custom_skills = resp.body.data.company_custom_skill_set
                    if self.custom_skills.length > 0
                        self.custom_skill.skill_uid_or_new = self.custom_skills[0].uid
                    else
                        self.custom_skill.skill_uid_or_new = ''
            .catch (resp)->
                n.catch_error(resp, "users_skills: get_company_custom_skills()")
            
    beforeMount: ()->
        # console.log "USERS SKILLS"
        @get_company_custom_skills()
}
